import { colors } from '../../lib/theme';
import { LENS_LABELS } from '../../lib/lens-labels';
import type { FilterToggles } from '../../lib/screening-presets';

function Bar({ width, height = 12 }: { width: number | string; height?: number }) {
  return (
    <span
      className="scan-pulse inline-block rounded"
      style={{ width, height, backgroundColor: colors.bgRaised }}
    />
  );
}

/**
 * Skeleton rows for the results table, shown while a screen is running.
 * Mirrors the real table's column set (based on active toggles) so the
 * layout doesn't jump when results arrive — perceived-performance fix
 * for 10E.9 (empty table + spinner only).
 */
export function SkeletonResultsTable({ toggles, rows = 6 }: { toggles: FilterToggles; rows?: number }) {
  return (
    <div
      className="mt-8 overflow-x-auto rounded-2xl"
      style={{ border: `1px solid ${colors.border}`, backgroundColor: colors.bgTertiary }}
      aria-hidden
    >
      <table className="w-full text-sm">
        <thead className="text-left">
          <tr style={{ borderBottom: `1px solid ${colors.border}` }}>
            <th className="py-3.5 px-4 text-[11.5px] font-semibold uppercase tracking-wide" style={{ color: colors.textMuted }}>Ticker</th>
            <th className="py-3.5 px-4 text-[11.5px] font-semibold uppercase tracking-wide" style={{ color: colors.textMuted }}>Company</th>
            {toggles.bds.enabled && (
              <th className="py-3.5 px-4 text-[11.5px] font-semibold uppercase tracking-wide" style={{ color: colors.textMuted }}>{LENS_LABELS.occupationShort}</th>
            )}
            {toggles.defense && (
              <th className="py-3.5 px-4 text-[11.5px] font-semibold uppercase tracking-wide" style={{ color: colors.textMuted }}>{LENS_LABELS.defenseShort}</th>
            )}
            {toggles.shariah && (
              <th className="py-3.5 px-4 text-[11.5px] font-semibold uppercase tracking-wide" style={{ color: colors.textMuted }}>{LENS_LABELS.shariahShort}</th>
            )}
            <th className="py-3.5 px-4 text-[11.5px] font-semibold uppercase tracking-wide" style={{ color: colors.textMuted }}>Final</th>
            <th className="py-3.5 px-4 text-[11.5px] font-semibold uppercase tracking-wide" style={{ color: colors.textMuted }}>Evidence</th>
            <th className="py-3.5 px-4 text-[11.5px] font-semibold uppercase tracking-wide" style={{ color: colors.textMuted }}>Sources</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, i) => (
            <tr key={i} style={{ borderBottom: `1px solid ${colors.borderDark}` }}>
              <td className="py-3.5 px-4"><Bar width={48} /></td>
              <td className="py-3.5 px-4"><Bar width={i % 2 === 0 ? 140 : 96} /></td>
              {toggles.bds.enabled && (
                <td className="py-3.5 px-4"><Bar width={64} height={18} /></td>
              )}
              {toggles.defense && (
                <td className="py-3.5 px-4"><Bar width={64} height={18} /></td>
              )}
              {toggles.shariah && (
                <td className="py-3.5 px-4"><Bar width={64} height={18} /></td>
              )}
              <td className="py-3.5 px-4"><Bar width={72} height={18} /></td>
              <td className="py-3.5 px-4"><Bar width={80} /></td>
              <td className="py-3.5 px-4"><Bar width={90} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
